import {
  UPDATE_MULTI_RESTAURANT_DETAILS,
  CLEAR_MULTI_RESTAURANT_DETAILS
} from "../actions";

export default function multiRestaurantDetails(state = {}, action) {
  switch (action.type) {
    case UPDATE_MULTI_RESTAURANT_DETAILS:
      return { ...state, ...action.payload };
    case CLEAR_MULTI_RESTAURANT_DETAILS:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/multiRestaurantDetails.js